import generalUpload from "../_section/upload.class";

export class userCriticalSkillsEmploymentPermitUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        },
        {
            name: 'expiryDate',
            label: 'Expiry Date',
            type: 'date',
        }
    ]
}

export class adminCriticalSkillsEmploymentPermitUpload extends userCriticalSkillsEmploymentPermitUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.expiryDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.expiryDate().subtract(3, 'month'),
            })
        }
    }
}
